var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.length >= 1)?_c('div',{staticClass:"banner_swiper-container"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.data),function(info,index){return _c('div',{key:`${info}${index}`,staticClass:"swiper-slide"},[_c('img',{attrs:{"src":info,"alt":""}})])}),0),_c('div',{staticClass:"swiper-pagination"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }